import type { ReactNode } from 'react'

import cn from './FilterOptionPills.module.scss'

export type FilterOptionPillItem = {
  key: string
  label: ReactNode
  selected: boolean
  disabled?: boolean
  /** Количество товаров с этим значением. В списочном режиме показывается как `(N)`. */
  count?: number
}

type FilterOptionPillsProps = {
  options: FilterOptionPillItem[]
  onToggle: (key: string) => void
}

function FilterOptionPills({ options, onToggle }: FilterOptionPillsProps) {
  return (
    <div className={cn.pillRow}>
      {options.map((option) => (
        <button
          key={option.key}
          type="button"
          className={[cn.pill, option.selected ? cn.selected : '']
            .filter(Boolean)
            .join(' ')}
          disabled={option.disabled}
          aria-pressed={option.selected}
          onClick={() => onToggle(option.key)}
        >
          {option.label}
          {option.count !== undefined && (
            <span className={cn.pillCount}>{option.count}</span>
          )}
        </button>
      ))}
    </div>
  )
}

export default FilterOptionPills
